var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreparacaoTerreno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.542,
    height: 52.031,
    viewBox: "0 0 62.542 52.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_985",
    "data-name": "Grupo 985",
    transform: "translate(-346.458 -612.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_968",
    "data-name": "Grupo 968",
    transform: "translate(358.462 617.648)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_967",
    "data-name": "Grupo 967",
    transform: "translate(-249.904 130.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6279",
    "data-name": "Caminho 6279",
    d: "M627.782,508.425l-2.966-6.743a1.07,1.07,0,0,0-1.07-1.07H612.86a1.07,1.07,0,0,0-1.07,1.07l-2.717,6.713H598.182a1.07,1.07,0,0,0-1.07,1.07v8.017a1.07,1.07,0,0,0,1.07,1.07h29.356a1.07,1.07,0,0,0,1.07-1.07v-8.017A1.07,1.07,0,0,0,627.782,508.425Z",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6280",
    "data-name": "Caminho 6280",
    d: "M622.479,503.709a.351.351,0,0,0-.351-.351h-5.739c-.325,0-.59.157-.59.351l-2.692,4.686v1.3c0,.194.265.351.59.351h5.882v5.035a.351.351,0,0,0,.351.351h5.1a.351.351,0,0,0,.351-.351v-4.247Z",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6281",
    "data-name": "Caminho 6281",
    d: "M614.283,498.107h9.246s1-2.084,9.68-6.338l-1.432-5.122S613.849,491.422,614.283,498.107Z",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6282",
    "data-name": "Caminho 6282",
    d: "M641.579,485.671h-.006a3.576,3.576,0,0,0-7.075.7,3.482,3.482,0,0,0,.185,1.118l-.006,0,6.055,16.734h4.428Z",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6283",
    "data-name": "Caminho 6283",
    d: "M641.644,506.933,634.5,516.7v1h6.755a5.262,5.262,0,0,0,3.907-4.124v-6.641Z",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_675",
    "data-name": "Ret\\xE2ngulo 675",
    width: 35.402,
    height: 10.027,
    rx: 5.014,
    transform: "translate(597.112 521.561)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_162",
    "data-name": "Elipse 162",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(602.962 525.508)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_163",
    "data-name": "Elipse 163",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(625.38 525.508)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_164",
    "data-name": "Elipse 164",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(618.177 525.508)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_165",
    "data-name": "Elipse 165",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(610.569 525.508)",
    fill: "none",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_166",
    "data-name": "Elipse 166",
    cx: 1.153,
    cy: 1.153,
    r: 1.153,
    transform: "translate(637.035 485.495)",
    fill: "#48af77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparacaoTerreno);
export default __webpack_public_path__ + "static/media/preparacao_terreno.001db5cb3fb85b8c901ca9c0454fd83a.svg";
export { ForwardRef as ReactComponent };